import type { IDesignAtomsVdpModel, ISurfacesData, TSurfaceData } from "../types/design-atoms.types";
import type { IDataSet, IRawSurfacesData } from "../types/table.types";

export class DesignAtomsVdpModel {
  private vdpDataSet: IDesignAtomsVdpModel = {
    SurfacesData: [],
  };

  constructor(
    private dataFromTable: IDataSet[],
    private surfacesRawData: IRawSurfacesData,
  ) {}

  serialize(): IDesignAtomsVdpModel {
    return this.vdpDataSet;
  }

  addSurfacesData() {
    const surfacesData = new SurfacesData();
    this.vdpDataSet.SurfacesData.push(surfacesData);
  }

  setSurfaceBinding() {
    const surfaceIndexes = this.getSurfacesIndexes();
    this.vdpDataSet.SurfacesData.forEach((_, surfaceIndex) => {
      this.vdpDataSet.SurfacesData[surfaceIndex].SurfaceBinding.SurfaceNames = null;
      this.vdpDataSet.SurfacesData[surfaceIndex].SurfaceBinding.SurfaceIndexes = surfaceIndexes;
      this.vdpDataSet.SurfacesData[surfaceIndex].IterateOverSurfacesFirst = false;
    });
  }

  setData() {
    // TODO: Check on multi-page design
    const surfaceIndex = 0;

    this.dataFromTable.forEach((dataSheet) => {
      dataSheet.rows.forEach((rowObject) => {
        const surfaceData = new SurfaceData() as TSurfaceData;
        Object.entries(rowObject.row).forEach(([key, value]) => {
          // TODO: Placeholders - maybe this is "{{ }}" template from any editor, but need to check
          surfaceData.Placeholders[key] = value;
          const columnType = this.getColumnType(key) || 'Text';
          surfaceData[key] = {
            [columnType]: value,
          };
        });
        if (!this.vdpDataSet.SurfacesData[surfaceIndex]) {
          this.addSurfacesData();
        }
        this.vdpDataSet.SurfacesData[surfaceIndex].Data.push(surfaceData);
      });
    });
  }

  getColumnType(columnKey: string): string | null {
    let columnEntry: [string, string] | null = null;

    this.surfacesRawData.columnsTypes.find((columnsObject) => {
      columnEntry = Object.entries(columnsObject).find(([key, _]) => key === columnKey) || null;
      return !!columnEntry;
    });
    
    if (!!columnEntry) {
      const columnType = columnEntry[1];
      return columnType;
    } else {
      return null;
    }
  }

  getSurfacesIndexes(): number[] {
    const surfacesIndexes: number[] = [];
    this.surfacesRawData.surfaces.forEach((surfaceData) => {
      surfacesIndexes.push(surfaceData.index);
    });
    return surfacesIndexes;
  }

}

export class SurfaceData {
  Surfaces: TSurfaceData['Surfaces'] = null;
  Placeholders: TSurfaceData['Placeholders'] = {};
}

export class SurfacesData {
  SurfaceBinding: ISurfacesData['SurfaceBinding'] = {
    SurfaceNames: null,
    SurfaceIndexes: [],
    IsSingleBinding: false,
  };
  Data: ISurfacesData['Data'] = [];
  IterateOverSurfacesFirst: ISurfacesData['IterateOverSurfacesFirst'] = false;
}